const ENV = process.env.NODE_ENV;
export default {
  baseUrl: BASE_URL[ENV],
  logoUrl:LOGO_URL
};
